import Checkers from '../../../helpers/class/Checkers';
import { useLocalePrefix } from '../../../helpers/i18n';
import {useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../../helpers/MethodHelper";

export default function FooterMenu ( props ) {
  const localeBase = useLocalePrefix();

  const showMenuItems = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_header_show_menu_items')
  );

  const referer = typeof window !== "undefined" ? window.location.origin + localeBase + '/' : ''

  const topLevelHref = (menu, loggiaUrl) => {
    if (menu.hasOwnProperty('redirectUrl')) {
      return menu.redirectUrl
    }

    const slug = Checkers.isValidString(loggiaUrl) ? loggiaUrl : (menu.urlSlug != null ? menu.urlSlug : null)
    if (slug == null) {
      return '#'
    }

    return referer + (slug.startsWith('/') ? slug.substring(1) : slug)
  }

  return (
      <>
        {
          showMenuItems == '1' ?
              <>
                <ul className={'d-flex flex-wrap justify-content-center justify-content-lg-start no-style no-padding font-arial fs-11'} style={{ marginLeft: -10 }}>
                  {
                      Checkers.isValidArray(props.menu) &&
                      props.menu.map((menu, key) => {
                        let loggiaUrl = menu.loggiaUrl;
                        if (Checkers.isValidString(loggiaUrl) && loggiaUrl.startsWith('/')) {
                          // loggiaUrl = loggiaUrl.substring(1);
                        }
                        return (
                            menu.title != null ?
                                // eslint-disable-next-line react/jsx-key
                                <li className={'inline'} key={key}>
                                  <a
                                      // href={menu.hasOwnProperty('redirectUrl') && Checkers.isValidString(menu.redirectUrl) ? menu.redirectUrl : (loggiaUrl != null ? referer + loggiaUrl : menu.urlSlug != null ? referer + menu.urlSlug : '#')}
                                      href={topLevelHref(menu, loggiaUrl)}
                                      className={`p-l-10 p-r-10 ${props.hasOwnProperty('apps') && props.apps == true ? 'opacity-60' : ''}`}>
                                    {menu.title}
                                  </a>
                                </li>
                                : ''
                        )
                      })
                  }
                </ul>
              </>
              :
              <><br /></>
        }
      </>
  )
}
